import { compareIso } from "./dates.js";
/**
 * Every packet of this thing, soonest first.
 *
 * Undated packets sort last rather than being dropped: "you have three, and one
 * of them has no date" is true and useful, while showing two of three is a
 * count the user can disprove by opening a cupboard.
 *
 * Ties keep their input order, so a batch of identically-dated packets does not
 * reshuffle itself between renders.
 */
export function batchTimeline(current, others) {
    const all = [current, ...others.filter((o) => o.id !== current.id)];
    const ordered = all
        .map((item, i) => ({ item, i }))
        .sort((a, b) => {
        const ax = a.item.expiry;
        const bx = b.item.expiry;
        if (ax && bx) {
            const byDate = compareIso(ax, bx);
            return byDate !== 0 ? byDate : a.i - b.i;
        }
        // Dated always beats undated; two undated keep their order.
        if (ax)
            return -1;
        if (bx)
            return 1;
        return a.i - b.i;
    })
        .map(({ item }) => item);
    const firstDated = ordered.find((x) => x.expiry !== null) ?? null;
    return ordered.map((item) => ({
        item,
        current: item.id === current.id,
        useFirst: firstDated !== null && item.id === firstDated.id,
    }));
}
/**
 * Is the packet being looked at already the right one to open?
 *
 * Split out because the two answers need opposite tones — a reassurance and a
 * redirection — and deciding which in the markup would put the rule where it
 * cannot be tested.
 */
export function isRightOne(slots) {
    const first = slots.find((s) => s.useFirst);
    // Nothing dated means nothing to be wrong about.
    return first ? first.current : true;
}
//# sourceMappingURL=batch.js.map